"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGroupAddon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("primereact/utils");
const InputGroupAddon = (props) => {
    return ((0, jsx_runtime_1.jsx)("span", { className: (0, utils_1.classNames)('p-inputgroup-addon', {
            'w-full': props.isFullWidth,
        }), children: props.children }));
};
exports.InputGroupAddon = InputGroupAddon;
exports.InputGroupAddon.defaultProps = {
    isFullWidth: false,
};
